import Box from '@mui/material/Box'
import { FC } from 'react'
import * as Yup from 'yup'

import EmptyState from 'components/EmptyState'
import Loading from 'components/Loading'
import { useListEventsForParticipantUpdate } from 'hooks/useListEventsForParticipantUpdate'
import { Event } from 'models/API'

import Form from './form'
import schema from './form/schema'

interface Props {
  onSubmit: (
    event: Event,
    values: Yup.InferType<typeof schema>,
  ) => Promise<void>
}

const Search: FC<Props> = ({ onSubmit }) => {
  const { events, apiLoading, apiError } = useListEventsForParticipantUpdate()

  const handleSubmit = async (values: Yup.InferType<typeof schema>) => {
    const event = events.find((e) => e.id === values.eventId)
    await onSubmit(event, values)
  }

  return (
    <Box sx={{ pb: 4 }}>
      <Loading loading={apiLoading} desc={'Fetching events'} />
      {apiError && (
        <EmptyState
          header={apiError.title}
          text={apiError.message}
          containerSx={{ textAlign: 'center' }}
        />
      )}
      {!apiLoading && <Form events={events} onSubmit={handleSubmit} />}
    </Box>
  )
}

export default Search
